import bootstrapLogo from "../images/Bootstrap-Logo.svg";
import bulmaLogo from "../images/Bulma-Logo.svg";
import cloudinaryLogo from "../images/Cloudinary-Logo.svg";
import cypressLogo from "../images/Cypress-Logo.svg";
import gitHubLogo from "../images/GitHub-Logo.svg";
import gitLabLogo from "../images/GitLab-Logo.svg";
import javaScriptES6Logo from "../images/JavaScript(ES6)-Logo.svg";
import mongoDBLogo from "../images/MongoDB-Logo.svg";
import nodeJsLogo from "../images/NodeJS-Logo.svg";
import nextJsLogo from "../images/NextJS-Logo.svg";
import npmLogo from "../images/NPM-Logo.svg";
import reactLogo from "../images/React-Logo.svg";
import reduxLogo from "../images/Redux-Logo.svg";
import sassLogo from "../images/Sass-Logo.svg";
import tailwindCssLogo from "../images/Tailwind-css-Logo.svg";
import typeScriptLogo from "../images/TypeScript-Logo.svg";
import visualStudioCodeLogo from "../images/Visual-Studio-Code-Logo.svg";
import vueJsLogo from "../images/Vue.js-Logo.svg";
import webstormLogo from "../images/Webstorm-Logo.svg";
import yarnLogo from "../images/Yarn-Logo.svg";
import gitKrakenLogo from "../images/GitKraken-Logo.svg";
import bitbucketLogo from "../images/Bitbucket-Logo.svg";
import mantineLogo from "../images/Mantine-Logo.svg";
import supabaseLogo from "../images/Supabase-Logo.svg";

export const toolsLogos: string[] = [
  reactLogo,
  reduxLogo,
  vueJsLogo,
  nodeJsLogo,
  nextJsLogo,
  javaScriptES6Logo,
  typeScriptLogo,
  cypressLogo,
  sassLogo,
  tailwindCssLogo,
  mantineLogo,
  bootstrapLogo,
  bulmaLogo,
  mongoDBLogo,
  supabaseLogo,
  cloudinaryLogo,
  npmLogo,
  yarnLogo,
  gitHubLogo,
  gitLabLogo,
  bitbucketLogo,
  gitKrakenLogo,
  visualStudioCodeLogo,
  webstormLogo,
];
